import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'subject-list',
    components: {
        // 'create-subject': Createsubject,
    },
})
export default class NudgeTypesPageComponent extends Vue {
    public isLoading: boolean = false;

    public createsubject() {        
    }
}
